// Type imports:
import { Requested } from '../../types/api/Types';
import { PrivateTradeReportTickData, IPrivateTrade } from '../../types/api/PrivateTypes';
import { ReportActions, REQUEST_ALERTS_SUMMARY_FAILURE, REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_FAILURE, REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_SUCCESS, REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_WAITING, REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_FAILURE, REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_SUCCESS, REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_WAITING, REQUEST_ALERTS_SUMMARY_SUCCESS, REQUEST_ALERTS_SUMMARY_WAITING, REQUEST_BROKEN_TRADE_REPORTS_FAILURE, REQUEST_BROKEN_TRADE_REPORTS_SUCCESS, REQUEST_BROKEN_TRADE_REPORTS_WAITING, REQUEST_CANCELLED_TRADES_FAILURE, REQUEST_CANCELLED_TRADES_SUCCESS, REQUEST_CANCELLED_TRADES_WAITING } from '../../types/redux/ReportTypes';
import { privateTradesToTickData } from './privateReducer';
import { IAlertsSummary, IAlertsSummaryPerClientId, IAlertsSummaryPerTraderId } from '../../types/api/ReportTypes';

export interface IReportState {
    cancelledTradesMap: {
        [datePair: string]: Requested<IPrivateTrade[]>,
    },
    brokenTradeReportsMap: {
        [datePair: string]: Requested<PrivateTradeReportTickData[]>
    },
    alertsSummaryMap: {
        [datePair: string]: Requested<IAlertsSummary[]>
    },
    alertsSummaryPerTraderIdMap: {
        [datePair: string]: Requested<IAlertsSummaryPerTraderId[]>
    },
    alertsSummaryPerClientIdMap: {
        [datePair: string]: Requested<IAlertsSummaryPerClientId[]>
    }
}

const initialState: IReportState = {
    cancelledTradesMap: {},
    brokenTradeReportsMap: {},
    alertsSummaryMap: {},
    alertsSummaryPerTraderIdMap: {},
    alertsSummaryPerClientIdMap: {}
}

export default function(state: IReportState = initialState, action: ReportActions) {
    switch(action.type) {
        // REQUEST CANCELLED TRADES
        case REQUEST_CANCELLED_TRADES_WAITING: {
            const { datePair } = action.payload;
            const cancelledTradesMapCopy = {...state.cancelledTradesMap};
            cancelledTradesMapCopy[datePair] = 'waiting';
            const newState: IReportState = {
                ...state,
                cancelledTradesMap: cancelledTradesMapCopy
            };
            return newState;
        }
        case REQUEST_CANCELLED_TRADES_SUCCESS: {
            const { cancelledTrades, datePair } = action.payload;
            const cancelledTradesMapCopy = {...state.cancelledTradesMap};
            cancelledTradesMapCopy[datePair] = cancelledTrades;
            const newState: IReportState = {
                ...state,
                cancelledTradesMap: cancelledTradesMapCopy
            };
            return newState;
        }
        case REQUEST_CANCELLED_TRADES_FAILURE: {
            const { error, datePair } = action.payload;
            const cancelledTradesMapCopy = {...state.cancelledTradesMap};
            cancelledTradesMapCopy[datePair] = { message: error };
            const newState: IReportState = {
                ...state,
                cancelledTradesMap: cancelledTradesMapCopy
            }
            return newState;
        };
        // REQUEST BROKEN TRADE REPORTS
        case REQUEST_BROKEN_TRADE_REPORTS_WAITING: {
            const { datePair } = action.payload;
            const brokenTradeReportsMapCopy = {...state.brokenTradeReportsMap};
            brokenTradeReportsMapCopy[datePair] = 'waiting';
            const newState: IReportState = {
                ...state,
                brokenTradeReportsMap: brokenTradeReportsMapCopy
            };
            return newState;
        }
        case REQUEST_BROKEN_TRADE_REPORTS_SUCCESS: {
            const { datePair, brokenGeniumTradeReports, brokenInetTradeReports } = action.payload;
            const brokenTradeReportsMapCopy = {...state.brokenTradeReportsMap};
            const { privateInetTradeReportsTickData, privateGeniumTradeReportsTickData } = privateTradesToTickData([], brokenInetTradeReports, brokenGeniumTradeReports);
            const brokenReports = [...privateInetTradeReportsTickData, ...privateGeniumTradeReportsTickData];
            brokenTradeReportsMapCopy[datePair] = brokenReports;
            const newState: IReportState = {
                ...state,
                brokenTradeReportsMap: brokenTradeReportsMapCopy
            };
            return newState;
        }
        case REQUEST_BROKEN_TRADE_REPORTS_FAILURE: {
            const { error, datePair } = action.payload;
            const brokenTradeReportsMapCopy = {...state.brokenTradeReportsMap};
            brokenTradeReportsMapCopy[datePair] = { message: error };
            const newState: IReportState = {
                ...state,
                brokenTradeReportsMap: brokenTradeReportsMapCopy
            }
            return newState;
        };
        // =================================== REQUEST ALERTS SUMMARY ===================================
        case REQUEST_ALERTS_SUMMARY_WAITING: {
            const { datePair } = action.payload;
            const alertsSummaryMapCopy = {...state.alertsSummaryMap};
            alertsSummaryMapCopy[datePair] = 'waiting';
            const newState: IReportState = {
                ...state,
                alertsSummaryMap: alertsSummaryMapCopy
            };
            return newState;
        }
        case REQUEST_ALERTS_SUMMARY_SUCCESS: {
            const { datePair, alertsSummary } = action.payload;
            const alertsSummaryMapCopy = {...state.alertsSummaryMap};
            alertsSummaryMapCopy[datePair] = alertsSummary;
            const newState: IReportState = {
                ...state,
                alertsSummaryMap: alertsSummaryMapCopy
            };
            return newState;
        }
        case REQUEST_ALERTS_SUMMARY_FAILURE: {
            const { error, datePair } = action.payload;
            const alertsSummaryMapCopy = {...state.alertsSummaryMap};
            alertsSummaryMapCopy[datePair] = { message: error };
            const newState: IReportState = {
                ...state,
                alertsSummaryMap: alertsSummaryMapCopy
            }
            return newState;
        };
        // =================================== REQUEST ALERTS SUMMARY PER TRADER ID ===================================
        case REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_WAITING: {
            const { datePair } = action.payload;
            const alertsSummaryPerTraderIdMapCopy = {...state.alertsSummaryPerTraderIdMap};
            alertsSummaryPerTraderIdMapCopy[datePair] = 'waiting';
            const newState: IReportState = {
                ...state,
                alertsSummaryPerTraderIdMap: alertsSummaryPerTraderIdMapCopy
            };
            return newState;
        }
        case REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_SUCCESS: {
            const { datePair, alertsSummaryPerTraderId } = action.payload;
            const alertsSummaryPerTraderIdMapCopy = {...state.alertsSummaryPerTraderIdMap};
            alertsSummaryPerTraderIdMapCopy[datePair] = alertsSummaryPerTraderId;
            const newState: IReportState = {
                ...state,
                alertsSummaryPerTraderIdMap: alertsSummaryPerTraderIdMapCopy
            };
            return newState;
        }
        case REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_FAILURE: {
            const { error, datePair } = action.payload;
            const alertsSummaryPerTraderIdMapCopy = {...state.alertsSummaryPerTraderIdMap};
            alertsSummaryPerTraderIdMapCopy[datePair] = { message: error };
            const newState: IReportState = {
                ...state,
                alertsSummaryPerTraderIdMap: alertsSummaryPerTraderIdMapCopy
            }
            return newState;
        };
        // =================================== REQUEST ALERTS SUMMARY PER CLIENT ID ===================================
        case REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_WAITING: {
            const { datePair } = action.payload;
            const alertsSummaryPerClientIdMapCopy = { ...state.alertsSummaryPerClientIdMap };
            alertsSummaryPerClientIdMapCopy[datePair] = 'waiting';
            const newState: IReportState = {
                ...state,
                alertsSummaryPerClientIdMap: alertsSummaryPerClientIdMapCopy
            };
            return newState;
        }
        case REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_SUCCESS: {
            const { datePair, alertsSummaryPerClientId } = action.payload;
            const alertsSummaryPerClientIdMapCopy = { ...state.alertsSummaryPerClientIdMap };
            alertsSummaryPerClientIdMapCopy[datePair] = alertsSummaryPerClientId;
            const newState: IReportState = {
                ...state,
                alertsSummaryPerClientIdMap: alertsSummaryPerClientIdMapCopy
            };
            return newState;
        }
        case REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_FAILURE: {
            const { error, datePair } = action.payload;
            const alertsSummaryPerClientIdMapCopy = { ...state.alertsSummaryPerClientIdMap };
            alertsSummaryPerClientIdMapCopy[datePair] = { message: error };
            const newState: IReportState = {
                ...state,
                alertsSummaryPerClientIdMap: alertsSummaryPerClientIdMapCopy
            };
            return newState;
        }

        // DEFAULT
        default: {
            return state;
        }
    }
}
